import {MasterDataObject} from "../../domain/dtos/master-data-object";

export class MasterDataObjectMapper {
    static deserialize(param: any): MasterDataObject {
        return {
            code: param.key,
            name: param.value
        } as MasterDataObject
    }
}
